import { useState } from "react";
import styles from "./expensePayeeFilter.module.css";
import { ArrowRight, Filter, Plus, Search } from "react-feather";
import { Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import FilterAutocomplete from "../../../../components/FilterAutocomplete";

const ExpensePayeeFilter = ({ setFilterData, setAddModalOpen, filterData, ExpenseCategories, setPage }) => {
  const { user, isAuthenticated } = useAuth0();
  const [filterOpen, setFilterOpen] = useState(false);

  const showFilter = () => {
    setFilterOpen(true);
  }

  const hideFilter = () => {
    setFilterOpen(false);
  };

  return (<div className={`${styles.SearchFilterSec}`}>
    <div className={`${styles.SearchCon}`}>
      <div className={`${styles.SearchConSec}`}>
        <Search />
        <input type="text" placeholder="Search" onChange={(e) => { setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; }); setPage(0); }} />
      </div>
    </div>
    <div className={`${styles.FilterSec}`}>
      <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
        <p className={`${styles.FilterTitle}`}>
          Filters
          <span onClick={hideFilter}>
            <ArrowRight />
          </span>
        </p>
        <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
          <FilterAutocomplete
            label="Category"
            options={(ExpenseCategories || []).map((i) => ({ value: i.id, label: i.title }))}
            value={filterData?.category}
            onChange={(value) => {
              setFilterData((prev) => ({ ...prev, category: value }));
              setPage(0);
            }}
          />
        </div>
      </div>

      <Link className={`${styles.FilterBu}`} onClick={showFilter}>
        <Filter />
      </Link>
      {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("expense-payee:create") > -1 && <Link className={`${styles.AddNoteBu}`} onClick={(e) => setAddModalOpen(true)}>
        <Plus /> <span>Payee</span>
      </Link>}
    </div>
  </div>);
}

export default ExpensePayeeFilter;